import React, { useEffect, useState } from "react";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { HttpService } from "../../../service/HttpService";
import { DataGrid } from "@mui/x-data-grid";
import { gridClasses } from "@mui/x-data-grid/constants";
import dayjs from "dayjs";
import MatricIdsListModal from "../../Model/MatricIdsListModal";

const baseStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 3,
  p: 4,
  width: "90%",
  maxWidth: "90%",
  maxHeight: "80vh",
  overflowY: "auto",
};

function ViewTrimmingDetailsModal({ open, handleClose, scheduleId }) {
  const httpService = new HttpService();
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  // Matric modal states
  const [matricModalOpen, setMatricModalOpen] = useState(false);
  const [selectedMatricRow, setSelectedMatricRow] = useState(null);

  const handleOpenMatricModal = (row) => {
    setSelectedMatricRow(row);
    setMatricModalOpen(true);
  };

  const fetchTrimmingData = async () => {
    setLoading(true);
    try {
      const res = await httpService.get(
        `harvest-trimming/schedule-task/${scheduleId}`,
      );
      setDetails(res?.data || []);
    } catch (e) {
      setDetails([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open && scheduleId) {
      fetchTrimmingData();
    }
  }, [open, scheduleId]);

  const columns = [
    // {
    //   field: "week_of_harvest",
    //   headerName: "Week of Harvest",
    //   flex: 1,
    //   minWidth: 130,
    // },
    {
      field: "harvest_date",
      headerName: "Harvest Date",
      flex: 1,
      minWidth: 140,
      renderCell: (params) => (
        <div style={{ padding: "10px" }}>
          {params.value ? dayjs(params.value).format("MM-DD-YYYY") : "-"}
        </div>
      ),
    },
    {
      field: "cultivar_name",
      headerName: "Cultivar Name",
      flex: 1,
      minWidth: 160,
      renderCell: (params) => (
        <div style={{ padding: "10px" }}>{params.value || "-"}</div>
      ),
    },
    {
      field: "room_name",
      headerName: "Room Name",
      flex: 1,
      minWidth: 140,
      renderCell: (params) => (
        <div style={{ padding: "10px" }}>{params.value || "-"}</div>
      ),
    },
    // {
    //   field: "plants",
    //   headerName: "Plants",
    //   flex: 1,
    //   minWidth: 100,
    //   renderCell: (params) => (
    //     <span
    //       style={{
    //         textDecoration: "underline",
    //         color: "#427fcfff",
    //         cursor: "pointer",
    //         padding: "10px",
    //       }}
    //       onClick={() => handleOpenMatricModal(params.row)}
    //     >
    //       {params.value || 0}
    //     </span>
    //   ),
    // },
    {
      field: "totes",
      headerName: "Totes",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "source_package_tag_name",
      headerName: "Source Package Tag",
      flex: 1.5,
      minWidth: 200,
      renderCell: (params) => (
        <div style={{ padding: "10px" }}>{params.value || "-"}</div>
      ),
    },
    // {
    //   field: "selected_matric_ids",
    //   headerName: "Matric IDs",
    //   flex: 1.5,
    //   minWidth: 200,
    //   renderCell: (params) => {
    //     const matrics = params.value;
    //     const text = Array.isArray(matrics) && matrics.length > 0 ? matrics.join(", ") : "-";
    //     return <div style={{ padding: "10px", whiteSpace: "normal", wordBreak: "break-all" }}>{text}</div>;
    //   },
    // },
    // {
    //   field: "child_package_tag_name",
    //   headerName: "Child Package Tag",
    //   flex: 1.5,
    //   minWidth: 200,
    //   renderCell: (params) => (
    //     <div style={{ padding: "10px" }}>{params.value || "-"}</div>
    //   ),
    // },
    // {
    //   field: "bulk_smalls_trim",
    //   headerName: "Bulk/Smalls/Trim",
    //   flex: 1,
    //   minWidth: 150,
    //   renderCell: (params) => (
    //     <div style={{ padding: "10px" }}>{params.value || "-"}</div>
    //   ),
    // },
    // {
    //   field: "weight",
    //   headerName: "Weight",
    //   flex: 1,
    //   minWidth: 120,
    //   renderCell: (params) => (
    //     <div style={{ padding: "10px" }}>
    //       {params.value ? `${params.value} lbs` : "-"}
    //     </div>
    //   ),
    // },
    // {
    //   field: "waste",
    //   headerName: "Waste",
    //   flex: 1,
    //   minWidth: 120,
    //   renderCell: (params) => (
    //     <div style={{ padding: "10px" }}>
    //       {params.value ? `${params.value} lbs` : "-"}
    //     </div>
    //   ),
    // },
  ];

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box sx={baseStyle}>
          {/* Header */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h5" fontWeight={600}>
              View Trimming Details
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Tab Content / Table */}
          <div
            style={{
              height: `${details?.length > 0 ? "auto" : "200px"}`,
              width: "100%",
              marginTop: 20,
            }}
          >
            <DataGrid
              rows={details}
              columns={columns}
              getRowId={(r) => r.id}
              loading={loading}
              pageSizeOptions={[5, 10, 15]}
              initialState={{
                pagination: {
                  paginationModel: { pageSize: 10, page: 0 },
                },
              }}
              sx={{
                backgroundColor: "#fff",
                border: "1px solid #E0E0E0",
                [`& .${gridClasses.columnHeader}`]: {
                  backgroundColor: "#F7F9FC",
                  color: "#374151",
                  fontWeight: 600,
                },
              }}
            />
          </div>
        </Box>
      </Modal>
      <MatricIdsListModal
        open={matricModalOpen}
        handleClose={() => {
          setMatricModalOpen(false);
          setSelectedMatricRow(null);
        }}
        row={selectedMatricRow}
      />
    </>
  );
}

export default ViewTrimmingDetailsModal;
